(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    var MQ = window.matchMedia('(max-width: 749px)');

    function initAccordions() {
      document.querySelectorAll('.gc-footer__col-toggle').forEach(function(btn) {
        if (btn._gcBound) return;
        btn._gcBound = true;
        btn.addEventListener('click', function() {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          var list = btn.nextElementSibling;
          if (list) list.classList.toggle('gc-footer__links--open', !expanded);
        });
      });
    }

    function applyMobile() {
      document.querySelectorAll('.gc-footer__col-toggle').forEach(function(btn) {
        var list = btn.nextElementSibling;
        if (MQ.matches) {
          btn.setAttribute('aria-expanded', 'false');
          if (list) list.classList.remove('gc-footer__links--open');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          if (list) list.classList.add('gc-footer__links--open');
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function() {
      initAccordions();
      applyMobile();
    });

    MQ.addEventListener('change', applyMobile);
  })();

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.btn = this.querySelector('[aria-expanded]');
      this.panel = this.querySelector('ul');
      this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
      if (!this.btn) return;
      this.btn.addEventListener('click', () => {
        const expanded = this.btn.getAttribute('aria-expanded') === 'true';
        this.btn.setAttribute('aria-expanded', String(!expanded));
        this.panel.toggleAttribute('hidden');
      });
      this.querySelectorAll('a[data-value]').forEach(a => {
        a.addEventListener('click', e => {
          e.preventDefault();
          this.input.value = a.dataset.value;
          this.closest('form').submit();
        });
      });
    }
  }
  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
